// extracted by mini-css-extract-plugin
export var printerCard = "_ah-1";
export var printerCardConfigured = "_ah-2";
export var printerCardError = "_ah-3";
export var printerCardsContainer = "_ah-0";
export var printerIcon = "_ah-8";
export var printerIconConfigured = "_ah-5";
export var printerIconContainer = "_ah-4";
export var printerIconError = "_ah-6";
export var printerIconUnconfigured = "_ah-7";
export var workstationsTableCard = "_ah-9";